import { jsx as e, jsxs as t, Fragment as i } from "react/jsx-runtime";
import { useState as s, useEffect as r } from "react";
import a from "./Dropzone.js";
import { ImageInfo as l } from "./ImageInfo.js";
import { MAX_FILE_SIZE as n } from "./constants.js";
const o = ({ icon: o2, defaultFilename: d, accept: c, description: u, value: p, onChange: f }) => {
  var _a, _b;
  const [m, h] = s({ status: "Idle" });
  r(() => {
    (async () => {
      p && !m.file && h({ status: "Idle", file: p });
    })();
  }, [m.file, p]);
  const I = () => {
    h({ status: "Idle" }), f(void 0);
    const e2 = document.querySelector("#fileUploader");
    e2 && (e2.value = "");
  }, F = c.split(",").map((e2) => e2.trim().toLowerCase());
  return "Idle" === m.status && p ? e(l, { icon: o2, title: d, description: t("span", { children: [((((_a = m.file) == null ? void 0 : _a.size) || 0) / 1024).toFixed(2), "Kb"] }), showDeleteButton: true, onDelete: I }) : t(i, { children: [t("label", { htmlFor: "fileUploader", children: [e("input", { type: "file", id: "fileUploader", hidden: true, accept: c, onChange: async (e2) => {
    try {
      const t2 = Array.from(e2.target.files || [])[0], i2 = t2.name.slice(t2.name.lastIndexOf(".")).toLowerCase();
      if (t2.size > n) return h({ status: "Failed", file: t2, error: "Розмір файлу не повинен перевищувати 1 МБ" });
      if (!F.includes(i2)) return h({ status: "Failed", file: t2, error: "Невірний формат" });
      h((e3) => ({ ...e3, status: "Complete", file: t2 })), f(t2);
    } catch (e3) {
      h({ status: "Failed", error: "Ой! Щось пішло не так" });
    }
  } }), "Idle" === m.status && e(a, { icon: o2, description: u })] }), "Idle" !== m.status && e(l, { icon: o2, isLoading: "Loading" === m.status, isSuccess: "Complete" === m.status, isInvalid: "Failed" === m.status, title: m.file.name, description: e(i, { children: "Failed" === m.status ? e("span", { children: m.error }) : t(i, { children: [t("span", { children: [((((_b = m.file) == null ? void 0 : _b.size) || 0) / 1024).toFixed(2), "Kb"] }), e("span", { children: "•" }), e("span", { children: m.status })] }) }), onDelete: I })] });
};
export {
  o as default
};
//# sourceMappingURL=FileUploader.js.map
